import { BoxProps } from 'grommet';
import { RightStatus } from 'lib/api';
import type { StatusTone } from '../components/ui/StatusPill';

/**
 * Entrance animation for page content: one short fade. Fields and dividers used to slide in on
 * staggered delays, which made every page feel slower than the API. prefers-reduced-motion turns
 * it off (globals.css).
 */
export const getAnimProps = (): BoxProps['animation'] => ({ type: 'fadeIn', duration: 150 });

/** How a right's status reads as a StatusPill */
export const rightStatusTone = (status?: RightStatus): StatusTone => {
  switch (status) {
    case RightStatus.ACTIVE:
      return 'ok';
    case RightStatus.EXPIRED:
      return 'danger';
    default:
      return 'neutral';
  }
};
